import { defineMessages } from 'react-intl';
import { SEO } from 'packages/theming/brands';

const seo: SEO = defineMessages({
  pageTitle: {
    id: './src/packages/theming/brands/single-parent-meet/seo:pageTitle',
    description: 'Page title',
    defaultMessage:
      'SingleParentMeet® | {routeTitle} | The Leading Online Dating Site for Singles & Personals',
  },
  pageDescription: {
    id: './src/packages/theming/brands/single-parent-meet/seo:pageDescription',
    description: 'Page Description',
    defaultMessage:
      'Are you a single mom or single dad? Parents without partners trust SingleParentsMeet.com to help them succeed at online dating.',
  },
  pageKeywords: {
    id: './src/packages/theming/brands/single-parent-meet/seo:pageKeywords',
    description: 'Page keywords',
    defaultMessage:
      'single parent meet,single parents,singleparentsmeet com,singleparentsmeet,single parents meet,single parent,single parent dating,singleparents com,singleparent com,parents without partners,single parents dating,singleparents,meet single parents,single parent meet com,single parents dating site,single parents com,single moms,single dads,single parent dating site,date single parents',
  },
});

export default seo;
